import React from 'react';
import {PayPalItem as Item} from 'FW/Models/PayPalItem';
import {File as FWFile} from 'FW/Models/File';

class PayPalItem extends React.Component {
  constructor(props) {
    super(...arguments);
    let itemID =
      this.props.section && this.props.section.prop('item_id')
        ? this.props.section.prop('item_id')
        : props.item.get('id');
    let item = Item.findOrCreate({id: itemID});
    const fileID = item.get('image_id');
    let file = FWFile.findOrCreate({id: fileID});
    if (!file.get('created_at')) {
      file.fetch().then(() => {
        this.forceUpdate();
      });
    }
    this.state = {
      item: item,
      itemID: item.get('id'),
      file: file,
      selectedOption: 0
    };
    this.encryptedOptionChanged = this.encryptedOptionChanged.bind(this);
  }

  getCurrencySymbol(currencyCode) {
    switch (currencyCode) {
      case 'EUR':
        return '€';
      case 'GBP':
        return '£';
      default:
        return '$';
    }
  }

  prettyPrintPrice(price, currencyCode) {
    price = parseFloat(price);
    return (
      this.getCurrencySymbol(currencyCode) +
      price.toFixed(2) +
      ' ' +
      currencyCode
    );
  }

  encryptedOptionChanged(e) {
    this.setState(
      {
        selectedOption: e.target.value
      },
      this.forceUpdate
    );
  }

  renderUnencryptedWithOptions() {
    let section = this.props.section;
    let options = section.prop('paypal_options');
    let item = this.state.item;
    let itemOptions = item.get('options');
    const selectOptions = itemOptions.map((option, i) => {
      return (
        <option key={i} value={option.name}>
          {option.name + ':  '}{' '}
          {this.prettyPrintPrice(option.price, item.get('currency'))}
        </option>
      );
    });
    const optionValues = itemOptions.map((option, i) => {
      return (
        <span key={i}>
          <input type="hidden" name={'option_select' + i} value={option.name} />
          <input
            type="hidden"
            name={'option_amount' + i}
            value={option.price}
          />
        </span>
      );
    });
    return (
      <div>
        <input type="hidden" name="business" value={options.business} />
        <input type="hidden" name="item_name" value={item.get('name')} />
        <input type="hidden" name="on1" value="Type" />
        <br />
        <select name="os1" style={{marginBottom: 10}}>
          {selectOptions}
        </select>{' '}
        <br />
        <input type="hidden" name="option_index" value="1" />
        {optionValues}
        <input
          type="hidden"
          name="currency_code"
          value={item.get('currency')}
        />
      </div>
    );
  }

  renderUnencrypted() {
    let section = this.props.section;
    let options = section.prop('paypal_options');
    let item = this.state.item;
    return (
      <div>
        <input type="hidden" name="business" value={options.business} />
        <input type="hidden" name="item_name" value={item.get('name')} />
        <input type="hidden" name="amount" value={item.get('price')} />
        <input type="hidden" name="shopping_url" value={window.location.href} />
        <input
          type="hidden"
          name="currency_code"
          value={item.get('currency')}
        />
      </div>
    );
  }

  renderEncrypted(i) {
    let section = this.props.section;
    let options = section.prop('paypal_options');
    let item = this.state.item;
    const encrypted = options.disable_encryption || typeof item.get('encryptedOptions') === 'undefined'
      ? null
      : '\n-----BEGIN PKCS7-----\n' +
        item.get('encryptedOptions')[i || 0].encrypted +
        '\n-----END PKCS7-----';
    return (
      <div>
        <input type="hidden" name="encrypted" value={encrypted} />
      </div>
    );
  }

  renderEncryptedWithOptions() {
    let item = this.state.item;
    let itemOptions = item.get('options');
    const selectOptions = itemOptions.map((option, i) => {
      return (
        <option key={i} value={i}>
          {option.name + ':  '}
          {this.prettyPrintPrice(option.price, item.get('currency'))}
        </option>
      );
    });
    return (
      <div>
        <select
          style={{marginBottom: 10}}
          onChange={this.encryptedOptionChanged}
          name={'selectEncryptedOption'}
        >
          {selectOptions}
        </select>
        <br />
        {this.renderEncrypted(this.state.selectedOption)}
      </div>
    );
  }

  renderViewCartButton() {
    let section = this.props.section;
    let options = section.prop('paypal_options');
    return (
      <form
        action="https://www.paypal.com/cgi-bin/webscr"
        target="PayPal"
        method="post"
      >
        <input type="hidden" name="cmd" value="_cart" />
        <input type="hidden" name="display" value="1" />
        <input type="hidden" name="business" value={options.business} />
        <input
          type="image"
          style={{display: 'inline-block'}}
          src="https://www.paypalobjects.com/en_US/i/btn/btn_viewcart_LG.gif"
          name="submit"
          alt="View PayPal Cart"
        />
        <img
          alt=""
          src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
          width="1"
          height="1"
        />
      </form>
    );
  }

  render() {
    let section = this.props.section;
    let options = section.prop('paypal_options');
    let item = this.state.item;
    let file = this.state.file;
    const thumbnailURL = file ? file.helper.featuredUrl(800) : null;
    let itemOptions = item.get('options');
    const viewCart = this.renderViewCartButton();

    let hasOptions = itemOptions && itemOptions.length > 0;

    return item ? (
      <div style={{textAlign: 'center'}}>
        {options.show_image && thumbnailURL ? (
          <img
            alt={item.get('name')}
            title={item.get('description')}
            src={thumbnailURL}
            style={{width: '100%'}}
          />
        ) : null}
        <h3>{item.get('name')}</h3>
        {options.show_description ? <p>{item.get('description')}</p> : null}
        {!hasOptions ? (
          <p>
            <strong>Price: </strong>
            {this.prettyPrintPrice(item.get('price'), item.get('currency'))}
          </p>
        ) : null}
        <form
          action="https://www.paypal.com/cgi-bin/webscr"
          method="post"
          target="paypal"
        >
          <input
            type="hidden"
            name="cmd"
            value={
              !options.disable_encryption ? '_s-xclick' : options.purchase_type
            }
          />
          {item.get('tax') !== -1 ? (
            <input type="hidden" name={'tax'} value={0} />
          ) : null}
          {item.get('weight') !== 0 ? [
            <input key="weight" type="hidden" name="weight" value={item.get('weight')} />,
            <input key="weight_unit" type="hidden" name="weight_unit" value="lbs" />
          ] : null}
          {options.purchase_type === '_cart' ? (
            <input type="hidden" name="add" value="1" />
          ) : null}
          {options.disable_encryption
            ? hasOptions
              ? this.renderUnencryptedWithOptions()
              : this.renderUnencrypted()
            : hasOptions
            ? this.renderEncryptedWithOptions()
            : this.renderEncrypted()}
          {options.allow_note ? <div className="form-group">
            <input type="hidden" name="on0" value="Notes" />
            <label>{options.note_field_title || 'Notes'}</label>
            <textarea className="form-control" name="os0" style={{width: 200, margin: 'auto'}} />
          </div> : null}
          <input
            style={{display: 'inline-block'}}
            type="image"
            name="submit"
            src={
              options.purchase_type === '_cart'
                ? 'https://www.paypalobjects.com/en_US/i/btn/btn_cart_LG.gif'
                : 'https://www.paypalobjects.com/en_US/i/btn/btn_buynow_LG.gif'
            }
            alt={options.purchase_type === '_cart' ? 'Add to Cart' : 'Buy Now'}
          />
          <img
            alt=""
            border="0"
            width="1"
            height="1"
            src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif"
          />
        </form>
        {options.purchase_type === '_cart' && options.show_view_cart_button
          ? viewCart
          : null}
      </div>
    ) : null;
  }
}

export default PayPalItem;
